import * as React from 'react';
import { ESuggestType } from '../../../../types';
import { getClosingForMatch } from '../../../../utils/text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ItemContent = function ItemContent(_ref) {
  var item = _ref.item;
  var text;
  var matchesUnsorted;
  if (item.type === ESuggestType.geo) {
    text = item.displayName;
    matchesUnsorted = item.hl;
  } else {
    text = item.name;
    matchesUnsorted = item.matches;
  }
  var matches = matchesUnsorted && matchesUnsorted.sort(function (matchA, matchB) {
    return matchA[0] - matchB[0];
  }) || [];
  var value = (text || '').trim();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!value || matches.length === 0 ? /*#__PURE__*/_jsx("span", {
      children: text
    }) : matches.map(function (match, index) {
      return /*#__PURE__*/_jsxs("span", {
        title: text,
        children: [index === 0 && text.substring(0, match[0]), /*#__PURE__*/_jsx("strong", {
          children: text.substring(match[0], match[1])
        }), getClosingForMatch(text, matches, index)]
      }, index);
    }), item.type === ESuggestType.underground && item.releaseYear && /*#__PURE__*/_jsx("span", {
      children: " \xB7 \u043E\u0442\u043A\u0440\u043E\u0435\u0442\u0441\u044F \u0432 ".concat(item.releaseYear)
    })]
  });
};